var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _iDBHandler_configFile;
import { piDB } from "./piDB";
export class iDBHandler {
    constructor(configFile) {
        _iDBHandler_configFile.set(this, void 0);
        __classPrivateFieldSet(this, _iDBHandler_configFile, configFile, "f");
        this.setupPiDB()
            .then(dbs => {
            this.databases = dbs;
        })
            .catch(e => {
        });
    }
    getDB(name) {
        return this.databases.find(x => x.DB_NAME === name);
    }
    async setupPiDB() {
        let configIDB = await this.loadConfig(__classPrivateFieldGet(this, _iDBHandler_configFile, "f"));
        console.log('SETUP_IDB', configIDB);
        let dbs = [];
        for (let idb of configIDB) {
            console.log('Loading DB', idb);
            let DB = new piDB(idb);
            dbs.push(DB);
        }
        return dbs;
    }
    async loadConfig(configFile) {
        let request = await fetch(configFile, {
            cache: 'no-store',
            headers: [
                ['Cache-Control', 'max-age=5']
            ]
        });
        const dbs = [];
        if (!request.ok)
            return dbs;
        try {
            let config = await request.json();
            return config;
        }
        catch (e) {
            return dbs;
        }
    }
}
_iDBHandler_configFile = new WeakMap();
//# sourceMappingURL=iDBHandler.js.map